/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a65453e10c9af5b7859a7b80002a749b3950a87a";
